/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Out_Dialog_Remove_LotInputs */

const vi_stock_out_dialog_remove_lot = /** @type {(inputs: Stock_Out_Dialog_Remove_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá lô`)
};

/**

* @param {Stock_Out_Dialog_Remove_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_dialog_remove_lot = /** @type {((inputs?: Stock_Out_Dialog_Remove_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Dialog_Remove_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_dialog_remove_lot(inputs)
});